/**
 * RequireWorkspaceAccess Guard
 * 
 * Ensures user has access to the specified workspace.
 * Returns null during loading, Navigate on failure, children on success.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

export type WorkspaceRole = 'viewer' | 'editor' | 'admin' | 'owner';

export interface RequireWorkspaceAccessProps {
  children?: ReactNode;
  hasAccess: boolean;
  loading: boolean;
  redirectTo?: string;
}

export function RequireWorkspaceAccess({
  children,
  hasAccess,
  loading,
  redirectTo = '/app/dashboard',
}: RequireWorkspaceAccessProps) {
  if (loading) {
    return null;
  }

  if (!hasAccess) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
